import { render, staticRenderFns } from "./EmailForBillWindow.vue?vue&type=template&id=10d6fdce&scoped=true&"
import script from "./EmailForBillWindow.vue?vue&type=script&lang=js&"
export * from "./EmailForBillWindow.vue?vue&type=script&lang=js&"
import style0 from "./EmailForBillWindow.vue?vue&type=style&index=0&id=10d6fdce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6fdce",
  null
  
)

export default component.exports